export default "__VITE_ASSET__CUixYAR4__"